<div class="modal-header">
    <h4 class="modal-title fs-5 text-reset text-capitalize">Afdelinger</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Luk" [disabled]="busy()"></button>
</div>
<div class="modal-body pb-0" [attr.aria-busy]="busy() || indexCardsStore.loading()">
    <form (ngSubmit)="newInstance()" class="mb-3">
        <label for="afdeling-name" class="form-label text-body-secondary">Ny afdeling</label>
        <div class="d-flex gap-2">
            <input #nameInput id="afdeling-name" name="name" type="text" class="form-control form-control-sm"
                   [ngModel]="name()" (ngModelChange)="name.set($event); error.set('')"
                   [disabled]="unavailable()" [attr.aria-invalid]="duplicate()"
                   aria-describedby="afdeling-duplicate afdeling-error" autocomplete="off" placeholder="Afdelingsnavn">
            <button class="btn btn-primary btn-sm" type="submit" [disabled]="unavailable() || !normalizedName() || duplicate()">Tilføj</button>
        </div>
        <div id="afdeling-duplicate" class="small text-danger mt-1" role="alert" [hidden]="!duplicate()">Navnet findes allerede. Vælg et andet navn.</div>
    </form>
    <div id="afdeling-error" class="small text-danger mb-2" role="alert" [hidden]="!error()">{{ error() }}</div>
    @if (indexCardsStore.loading()) {
        <p class="text-body-secondary" role="status">Indlæser afdelinger…</p>
    } @else if (indexCardsStore.loadError()) {
        <p class="text-danger" role="alert">Data kunne ikke hentes. <button type="button" class="btn btn-sm btn-link" (click)="indexCardsStore.init()">Prøv igen</button></p>
    } @else {
        <table class="table table-hover table-sm align-middle mb-0">
            <thead>
                <tr class="border-bottom">
                    <th scope="col" class="fw-normal small text-body-secondary py-2">Navn</th>
                    <th scope="col" class="fw-normal small text-body-secondary text-end py-2">Medarbejdere</th>
                    <th scope="col"><span class="visually-hidden">Handlinger</span></th>
                </tr>
            </thead>
            <tbody>
                @for (item of items(); track item.id) {
                    <tr class="border-bottom border-light-subtle">
                        <td class="py-2 text-break">{{ item.afdelingsnavn }}</td>
                        <td class="text-end text-body-secondary py-2">{{ item.employeeCount }}</td>
                        <td class="text-end py-2">
                            <button (click)="deleteInstance(item)" class="btn btn-link btn-sm text-danger text-decoration-none py-0 pe-0" type="button"
                                    [disabled]="unavailable()" [attr.aria-label]="'Slet ' + item.afdelingsnavn">Slet</button>
                        </td>
                    </tr>
                } @empty {
                    <tr><td colspan="3" class="text-center text-body-secondary py-4">Ingen afdelinger endnu.</td></tr>
                }
            </tbody>
        </table>
    }
</div>
<div class="d-flex justify-content-between px-3 py-2 small text-body-secondary">
    @if (!indexCardsStore.loading() && !indexCardsStore.loadError()) {
        <span>{{ items().length }} {{ items().length === 1 ? 'afdeling' : 'afdelinger' }}</span>
    }
    <span role="status">{{ busy() ? 'Behandler…' : '' }}</span>
</div>
